export const invoices = {
  main: "Invoices",
};
